const expand = require('./src/expand');
const join = require('./src/join');
const joinPartialPaths = require('./src/join-partial-paths');
const set = require('./src/set');
const split = require('./src/split');
const splitRoute = require('./src/split-route');
const normalise = require('./src/normalise');
const parseRef = require('./src/parse-ref');
const isRef = require('./src/is-ref');
const isPending = require('./src/is-pending');
const isNotFound = require('./src/is-not-found');
const isError = require('./src/is-error');
const isInvalidate = require('./src/is-invalidate');
const jsonUtils = require('./src/json-utils');
const keyUtils = require('./src/key-utils');
const match = require('./src/match');
const processPaths = require('./src/process-paths');
const constants = require('./src/constants');
const addPathPrefix = require('./src/add-path-prefix');
const removePathPrefix = require('./src/remove-path-prefix');
const ref = require('./src/ref');
const error = require('./src/error');
const getAll = require('./src/get-all');
const getValues = require('./src/get-values');
const watchAll = require('./src/watch-all');
const watchValues = require('./src/watch-values');
const toValues = require('./src/to-values');
const isPromise = require('./src/is-promise');
const isObservable = require('./src/is-observable');
const toObservable = require('./src/to-observable');
const getValueType = require('./src/get-value-type');
const isDynamicRoute = require('./src/is-dynamic-route');

const RouteMatcher = require('./src/route-matcher');
const MusterError = require('./src/muster-error');

module.exports = Object.assign({
  expand,
  join,
  joinPartialPaths,
  set,
  split,
  splitRoute,
  normalise,
  parseRef,
  isRef,
  isPending,
  isNotFound,
  isError,
  isInvalidate,
  addPathPrefix,
  removePathPrefix,
  ref,
  error,
  getAll,
  getValues,
  watchAll,
  watchValues,
  toValues,
  isPromise,
  isObservable,
  toObservable,
  getValueType,
  isDynamicRoute,
  RouteMatcher,
  MusterError,
}, jsonUtils, keyUtils, match, processPaths, constants);
